<template>
  <div v-if="currentCategory != null">
    <confirm-dialog ref="confirmDialog"
                    confirm-button-color="deep-orange"
                    v-bind:cancel-button-label="$t('cancel')"
                    v-bind:confirm-button-label="$t('delete')"
                    v-bind:message="$t('areYouSureYouWantToDeleteThisCategoryIrrevocably')"
                    v-bind:title="$t('deleteCategory')"
                    v-model="confirmDialog" />

    <v-snackbar color="deep-orange"
                right
                top
                v-model="validationSnackbar">
      {{ $t('thereAreItemsThatRequireYourAttention') }}
    </v-snackbar>

    <top-header v-bind:title="currentCategory.title">
      <header-button icon="mdi-chevron-left"
                     left
                     slot="left-button"
                     v-bind:label="$t('back')"
                     v-bind:to="{ name: 'administration-categories' }" />
      <header-button icon="mdi-check"
                     right
                     slot="right-button"
                     v-bind:label="$t('save')"
                     v-on:click="updateCurrentCategory" />
      <v-menu slot="menu">
        <template v-slot:activator="{ on, attrs }">
          <v-btn dark
                 icon
                 v-bind="attrs"
                 v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list class="py-0">
          <v-list-item v-on:click="deleteCurrentCategory">
            <v-list-item-title class="deep-orange--text">{{ $t('delete') }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </top-header>
    <v-container>
      <category-details-card ref="categoryDetailsCard"
                             v-bind:category="currentCategory" />
    </v-container>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'

  import CategoryDetailsCard from '@/components/CategoryDetailsCard'
  import ConfirmDialog from '@/components/common/ConfirmDialog'
  import HeaderButton from '@/components/common/HeaderButton'
  import TopHeader from '@/components/common/TopHeader'

  export default {
    components: {
      CategoryDetailsCard,
      ConfirmDialog,
      HeaderButton,
      TopHeader
    },
    computed: {
      ...mapGetters([ 'category' ])
    },
    async created() {
      const id = parseInt(this.$route.params.id)

      await this.get(id)
    },
    data: () => ({
      confirmDialog: false,
      currentCategory: null,
      id: null,
      validationSnackbar: false
    }),
    methods: {
      async get(id) {
        this.id = id

        await this.loadCategories()

        this.currentCategory = Object.assign({}, this.category(id))
      },
      async deleteCurrentCategory() {
        await this.$refs.confirmDialog.open(async r => {
          if (!r) {
            return
          }

          this.deleteCategory({ id: this.id })

          this.$router.push({ name: 'administration-categories' })
        })
      },
      async updateCurrentCategory() {
        if (!this.$refs.categoryDetailsCard.validate()) {
          this.validationSnackbar = true

          return
        }

        await this.updateCategory({ category: this.currentCategory })

        this.$router.push({ name: 'administration-categories' })
      },
      ...mapActions([
        'deleteCategory',
        'loadCategories',
        'updateCategory'
      ])
    },
    name: 'Category'
  }
</script>

<i18n>
  {
    "de": {
      "areYouSureYouWantToDeleteThisCategoryIrrevocably": "Sind Sie sicher, dass Sie diese Kategorie unwiderruflich löschen möchten?",
      "back": "Zurück",
      "cancel": "Abbrechen",
      "delete": "Löschen",
      "deleteCategory": "Kategorie löschen",
      "thereAreItemsThatRequireYourAttention": "Es gibt Felder, die Ihre Aufmerksamkeit erfordern.",
      "save": "Speichern",
      "saved": "Gespeichert"
    },
    "en": {
      "areYouSureYouWantToDeleteThisCategoryIrrevocably": "Are you sure you want to delete this category irrevocably?",
      "back": "Back",
      "cancel": "Cancel",
      "delete": "Delete",
      "deleteCategory": "Delete category",
      "thereAreItemsThatRequireYourAttention": "There are items that require your attention.",
      "save": "Save",
      "saved": "Saved"
    }
  }
</i18n>